"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormStatusMessage = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Wrapper = _interopRequireDefault(require("../Wrapper"));
var _Heading = _interopRequireDefault(require("../Text/Heading"));
var _tokens = require("../../tokens");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * [1] Ensure text within FormStatusMessage instances is aligned correctly.
 *     Without this if FormStatusMessage is nested within a container where text
 *     is center aligned (for example) the text within this component inherits
 *     that center alignment which we never want.
 */
const StyledFormStatusMessage = (0, _styledComponents.default)(props => /*#__PURE__*/_react.default.createElement(_Wrapper.default, _extends({
  background: _tokens.COLOR.WHITE,
  borderRadius: "S",
  bordered: true,
  padding: "S",
  paddingFromM: "M"
}, props))).withConfig({
  displayName: "StyledFormStatusMessage",
  componentId: "sc-fgf4gf-0"
})(["border-color:", ";border-width:2px;color:", ";text-align:start;ul{list-style:disc outside;margin:0;padding-left:", ";position:relative;}"], _ref => {
  let {
    $status
  } = _ref;
  return $status === 'error' ? _tokens.COLOR.STATE.ERROR : _tokens.COLOR.STATE.SUCCESS;
}, _tokens.COLOR.BLACK, _tokens.GTR.M);

/**
## Usage

```jsx
import { FormStatusMessage } from '@farewill/ui'
```

### How to use this component

Use this component at the top of a page to summarise any errors a user has made or communicate a successful action that has been completed.

When a user makes an error, you must show both an error summary and an error message next to each answer that contains an error. For errors, whenever applicable, use the variation with links to help guide users to the right field to correct the mistake.

If there are 2 or more errors, use a bulleted list.

#### Location

Put the error summary at the top of the main container, above the H1.

#### Error messages

Make sure the error messages in the error summary are worded the same as those which appear next to the inputs with errors.

Make your error messages clear and concise.

 */
const FormStatusMessage = _ref2 => {
  let {
    children,
    className,
    title,
    status = 'success'
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(StyledFormStatusMessage, {
    $status: status,
    className: className
  }, !!title && /*#__PURE__*/_react.default.createElement(_Heading.default, {
    size: "S",
    tag: "h2"
  }, title), children);
};
exports.FormStatusMessage = FormStatusMessage;